// extracted by mini-css-extract-plugin
export default {"row":"row__zkv1t","profile":"profile__CPabe","git":"git__-aSnb","link":"link__qd4sA"};